import { createApi } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import getTenantId from "../../components/Tenent";
import { showAccessDeniedModal, showSessionExpiredModal } from "../slices/authSlice";
const getStore = () => require("../store").store;

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.headers["x-tenant-id"] = getTenantId();
    return config;
  },
  (error) => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && window.location.pathname !== "/login") {
      getStore().dispatch(showSessionExpiredModal(window.location.pathname));
    }
    return Promise.reject(err);
  },
);

const axiosBaseQuery =
  () =>
  async ({ url, method, body, params, ...requestOpts }) => {

    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      const errorData = axiosError.response?.data;
      const status = axiosError.response?.status;

      if (status === 403 && errorData?.error === "forbidden") {
        getStore().dispatch(showAccessDeniedModal());
      }
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const Uploads3stream = createApi({
  reducerPath: "uploads3streamApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["uploads3stream"],
  endpoints: (builder) => ({
    Uploadcustomdatastream: builder.mutation({
      query: ({ token, payload, queryParams }) => {
        const queryString = new URLSearchParams(queryParams).toString();


        return {
          url: `/upload_file/?${queryString}`,
          method: "POST",
          body: payload,

          headers: {
            Authorization: `Bearer ${token}`,
            "X-Tenant-Id": getTenantId(),
          },
        };
      },
      invalidatesTags: ["input-items"],
    }),
  }),
});

export const { useUploadcustomdatastreamMutation } = Uploads3stream;
